<template>
    <div>
        <h1>Coach Area</h1>
        <modal v-show="showModal"
               @close-modal="closeModal"
               @assign-member="assignMember"
                v-bind:content="{operationList}"
        ></modal>
        <search @send-user="sendUser"
                @open-modal="openModal"
                v-bind:content="{userList}"
        ></search>
    </div>
</template>

<script>
    import {mixin} from '../../helpers/helper'
    import {createHelpers} from 'vuex-map-fields';
    import Search from '../../components/adm/coach_partials/search';
    import Modal from '../../components/adm/coach_partials/modal_operation';

    const {mapFields} = createHelpers({
        getterType: 'coach/getField',
        mutationType: 'coach/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Search, Modal, },
        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['searchText', 'userList', 'showModal', 'id', 'operationList', 'operationData']),
        },
        created: function () {

        },
        methods: {
            sendUser: function (searchText) {
                this.searchText = searchText;
                this.$store.dispatch('coach/searchUser');
            },

            openModal: function(id)
            {
                this.id = id;
                this.$store.dispatch('coach/openModal');
            },

            closeModal: function()
            {
                this.$store.dispatch('coach/closeModal');
            },

            assignMember: function(u)
            {
                this.operationData = u;
                this.$store.dispatch('coach/assignMember');
            }
        }
    }
</script>